export default __webpack_public_path__ + "static/media/4692@2x.d01579bc.png";